export const SUBPUSH_PAGES = [
  "/hair/women/product/core/women-advanced/3-month/",
  "/hair/women/product/core/balance/3-month/",
  "/hair/women/product/core/postpartum/3-month/",
  "/hair/men/product/core/men/3-month/",
];

export const ACCOUNT_PAGES = [
  "/customer/account/create/",
  "/customer/account/login/",
  "/customer/account/forgotpassword/",
  "/customer/account/code/",
  "/customer/account/password/",
  "/customer/account/password/forgot/",
];

export const PDP_PAGES = [
  //PDP
  "/hair/women/product/core/women-advanced/",
  "/hair/women/product/core/balance/",
  "/hair/women/product/core/postpartum/",
];

export const PDP_MEN_PAGES = [
  //PDP
  "/hair/men/product/core/men/",
  "/hair/men/product/core/men50/",
  "/hair/men/product/core/men-supplements/",
];

export const DUO_PAGES = [
  //DUO
  "/hair/women/product/booster/hair-growth-resilience-duo/",
  "/hair/women/product/booster/hair-growth-synbiosis-duo/",
  "/hair/women/product/booster/hair-growth-strength-duo/",
  "/hair/women/product/booster/hair-growth-shield-duo/",
  "/hair/women/product/booster/hair-growth-longevity-duo/",
  "/hair/women/product/booster/hair-growth-equilibrium-duo/",
  "/hair/women/product/kit/fullest-hair-kit/",
];
export const DUO_MEN_PAGES = [
  "/hair/men/product/booster/hair-growth-resilience-duo/",
  "/hair/men/product/booster/hair-growth-synbiosis-duo/",
  "/hair/men/product/booster/hair-growth-strength-duo/",
  "/hair/men/product/booster/hair-growth-shield-duo/",
  "/hair/men/product/booster/hair-growth-longevity-duo/",
  "/hair/men/product/booster/hair-growth-defense-duo/",
  "/hair/men/product/kit/core-hair-serum/",
  "/men/products/thinning-hair-supplements-and-shampoo-conditioner/",
];

export const PCP_MEN_PAGES = ["/hair/men/product/category/"];
export const PCP_PAGES = ["/hair/women/product/category/"];
export const GROWTH_PAGES = [
  "/hairgrowthpartners/",
  "/bundledhairgrowth/search/",
  "/hair/brand/lp/core/bundled-hair-growth/",
];

export const NO_RIBBONLINK_PAGES = [
  ...PDP_PAGES,
  ...PDP_MEN_PAGES,
  ...DUO_PAGES,
  ...DUO_MEN_PAGES,
  ...PCP_PAGES,
  ...PCP_MEN_PAGES,
  ...GROWTH_PAGES,
];

export const NO_RIBBONLINK_MEN_PAGES = [...PDP_MEN_PAGES, ...DUO_MEN_PAGES, ...PCP_MEN_PAGES];
export const CAPTCHA_PAGES = [
  "login",
  "create",
  "password",
  "profile",
  "subscriptions",
  "edit-address",
  "edit",
  "privacy-policy",
  "privacy-request",
];

export const MAY_GIFTING_CART_DATA = [
  {
    codes: ["WOMGIFT", "WOMCHRNGIFT"],
    sku: "WOMGWP",
    image:
      "https://images.ctfassets.net/0rbfqd9c4jdo/13Bd77Aiysign2P5x34x2L/7f00549f942278e3af603be662fcaa3a/women-cart-may-gwp-gift.jpeg",
  },
  {
    codes: ["BALGIFT", "BALCHRNGIFT"],
    sku: "BALGWP",
    image:
      "https://images.ctfassets.net/0rbfqd9c4jdo/8IIxp0zj6AxzoTj9F3sr8/27f43c805537dbc457d7ca9d5317913f/balance-cart-may-gwp-gift.jpeg",
  },
  {
    codes: ["POSGIFT", "POSCHRNGIFT"],
    sku: "POSGWP",
    image:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1r3J5F6qbLw0raiDmwfnyM/59f42fe36e9b77ca805ac75930954f0c/postpartum-cart-may-gwp-gift.jpeg",
  },
  {
    codes: ["MENGIFT", "MENCHRNGIFT"],
    sku: "MENGWP",
    image:
      "https://images.ctfassets.net/0rbfqd9c4jdo/23CiYhi0jhjXiXyGEBI5YP/e03706e48a58f86b76039203895b5282/men-cart-may-gwp-gift.jpeg",
  },
];
